import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonCellModel extends ModeModelBase {
  override _name = 'pythonCell';
  override belongsTo = 'pythonNotebook';
  override idAttribute = 'token';
  override hasOne = [{ name: 'pythonCellRun', as: 'lastPythonCellRun' }];
  override hasMany = [{ name: 'pythonCellRuns', idAttribute: 'token' }];
  override attributes = [
    { name: 'createdAt', default: '' },
    { name: 'content_type', default: '' },
    { name: 'content', default: '' },
    { name: 'frozen_in_layout', default: false },
    { name: 'next_cell_token' }, // write only field, never set by the server
  ];
}

@Injectable({ providedIn: 'root' })
export class PythonCellModelAccessor extends ModelAccessorBase<PythonCellModel> {
  override name = 'pythonCell';
  override idAttribute = 'token';
  override parentModel = 'pythonNotebook';
  override getIdFromLink = (link) => {
    return link.split('/cells/')[1];
  };
  createModel(resource, opts?) {
    const model = new PythonCellModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonCell');
  }
}
